import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { PageCarousel } from './components/PageCarousel';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { shortTestimonials, moreTestimonials } from './data/testimonials';
// import { PurchaseNotifications } from './components/PurchaseNotifications'
// Mount <PurchaseNotifications /> again once data/recentPurchases.ts is fed by real orders.

export function App() {
  return <div className="min-h-screen w-full bg-navy text-white font-sans selection:bg-gold selection:text-gold-ink" data-id="element-0" data-mp="3mjzs7369700r">
      <MetaPixel data-id="element-1" data-mp="3rd18nfm3z7mg" />
      <main data-id="element-2" data-mp="3relvsk63foaa">
        <Hero data-id="element-3" data-mp="5otf64sd496" />
        <SocialProofBar data-id="element-4" data-mp="6htjo98ovic" />
        <PainGrid data-id="element-5" data-mp="4n6o4eeqtbm" />
        <ProductReveal data-id="element-6" data-mp="56lhc8rh1lf" />
        <Tomes data-id="element-7" data-mp="2zl3azit8d249" />
        <PageCarousel data-id="element-8" data-mp="2zllff2q1qmn9" />
        <Bonuses data-id="element-9" data-mp="2zm4xcjfp5b1a" />
        <ValueStack data-id="element-10" data-mp="2zmo5j8fjol24" />
        <Urgency data-id="element-11" data-mp="2zn678kkz7rhf" />
        <Pricing data-id="element-12" data-mp="33moqzd129wio" />
        <Testimonials testimonials={shortTestimonials} background="white" data-id="element-13" data-mp="33m5e4aq9pybi" />
        <Guarantee data-id="element-14" data-mp="38lrpeemjd4ho" />
        <Faq data-id="element-15" data-mp="38l8eviz7tido" />
        <Testimonials testimonials={moreTestimonials} title="More coaches, fewer kids in line" background="cream" data-id="element-16" data-mp="38kqb81a841vq" />
        <CostOfInaction data-id="element-17" data-mp="3dii716dzo857" />
        <Close data-id="element-18" data-mp="nw2bq4xkjoqk" />
      </main>
      <Footer data-id="element-19" data-mp="nur8c681cizz" />
    </div>;
}